app.factory("imageUtilService", function ($q) {
    return {
        // 画像補正＆圧縮処理
        getCompressedImage : function(imgbase64, compress, orientation) {
            var deferred = $q.defer();
            var imageObj = new Image();
            imageObj.onload = function () {
                var dstHeight = imageObj.height * compress;
                var dstWidth = imageObj.width * (dstHeight / imageObj.height);
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                canvas.width = dstWidth;
                canvas.height = dstHeight;
                ctx.save();
                var width  = canvas.width;
                var height = canvas.height;
                if (orientation) {
                    if (orientation > 4) {
                        canvas.width = height;
                        canvas.height = width;
                    }
                    switch (orientation) {
                        case 2:
                            ctx.translate(width, 0);
                            ctx.scale(-1, 1);
                            break;
                        case 3:
                            ctx.translate(width, height);
                            ctx.rotate(Math.PI);
                            break;
                        case 4:
                            ctx.translate(0, height);
                            ctx.scale(1, -1);
                            break;
                        case 5:
                            ctx.rotate(0.5 * Math.PI);
                            ctx.scale(1, -1);
                            break;
                        case 6:
                            ctx.rotate(0.5 * Math.PI);
                            ctx.translate(0, -height);
                            break;
                        case 7:
                            ctx.rotate(0.5 * Math.PI);
                            ctx.translate(width, -height);
                            ctx.scale(-1, 1);
                            break;
                        case 8:
                            ctx.rotate(-0.5 * Math.PI);
                            ctx.translate(-width, 0);
                            break;
                    }
                }
                ctx.drawImage(imageObj, 0, 0, dstWidth, dstHeight);
                ctx.restore();
                deferred.resolve(canvas.toDataURL("image/jpeg"));
            }
            imageObj.src = imgbase64;
            return deferred.promise;
        },
        // 画像のEXIF情報からorientation値を取得
        getOrientation : function(imgbase64) {
            var head = 0;
            var orientation;
            var img = atob(imgbase64.split(',')[1]);
            while (1) {
                if (img.charCodeAt(head) == 255 & img.charCodeAt(head + 1) == 218) { break; }
                if (img.charCodeAt(head) == 255 & img.charCodeAt(head + 1) == 216) {
                    head += 2;
                }
                else {
                    var length = img.charCodeAt(head + 2) * 256 + img.charCodeAt(head + 3);
                    var endPoint = head + length + 2;
                    if (img.charCodeAt(head) == 255 & img.charCodeAt(head + 1) == 225) {
                        var segment = img.slice(head, endPoint);
                        var bigEndian = segment.charCodeAt(10) == 77;
                        var count;
                        if (bigEndian) {
                            count = segment.charCodeAt(18) * 256 + segment.charCodeAt(19);
                        } else {
                            count = segment.charCodeAt(18) + segment.charCodeAt(19) * 256;
                        }
                        for (i = 0; i < count; i++) {
                            var field = segment.slice(20 + 12 * i, 32 + 12 * i);
                            if ((bigEndian && field.charCodeAt(1) == 18) || (!bigEndian && field.charCodeAt(0) == 18)) {
                                orientation = bigEndian ? field.charCodeAt(9) : field.charCodeAt(8);
                            }
                        }
                        break;
                    }
                    head = endPoint;
                }
                if (head > img.length) { break; }
            }
            return orientation;
        }
    };
});
